



















import { Component, Vue } from 'vue-property-decorator';

import EditLayout from '../EditLayout.vue';
import Layout from '@/layouts/Default.vue';
import ListBlock from '@/views/CRUD/ListTab.vue';
import ConclusionsModule from '@/store/patients/conclusions';

import { editTabsNav } from "@/store/patients/tabs";

@Component({
    components: {
        EditLayout,
        Layout,
        ListBlock,
    }
})
export default class PatientsEditConsultationsPage extends Vue {
    repository = ConclusionsModule;

    get settings() {
        return this.repository.pageSettings;
    }

    get tabsNav() {
        return editTabsNav;
    }

    get currentTab() {
        const tabs = Object.values(this.tabsNav);
        const currentTab = tabs.find(tab => tab.pathName === this.$route.name);

        return currentTab?.id ?? '';
    }

    get patientId() {
        return this.$route.params.patientsId;
    }

    get filterSettings() {
        return ConclusionsModule.filter.filterSettings;
    }

    toAdd() {
        this.$router.push({ name: 'clinics_create' });
    }

    async updateList() {
        await ConclusionsModule.filter.updateFilter();
        await ConclusionsModule.getList();
    }

    async resetFilters() {
        await ConclusionsModule.clearSort();
        await ConclusionsModule.filter.resetFilter();
        await ConclusionsModule.getList();
    }

    async created() {
        await ConclusionsModule.setPatientId(this.patientId);
    }

    beforeDestroy() {
        ConclusionsModule.clearList()
    }
}
